import moment from 'moment';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { IReducer } from '../../../../../../redux/configureStore';
import { getOutstandingDebitsList } from '../../../../../../redux/fetchActions/legadoPage/outstandingDebitsApp';
import SearchButton from '../../../../../../shared/components/buttons/SearchButton';
import Filter from '../../../../../../shared/components/Filter';
import SetFare from './components/SetFare';
import SetFinalDate from './components/SetFinalDate';
import SetInitialDate from './components/SetInitialDate';
import SetPartner from './components/SetPartner';

function OutstandingDebitsFilter() {
  const dispatch = useDispatch();

  const outstandingDebitsFilterState = useSelector(
    (reducer: IReducer) => reducer.outstandigDebitsFilter
  );

  const profileNivelState = useSelector(
    (reducer: IReducer) => reducer.partnerProfile
  );

  function dispathData() {
    if (profileNivelState.nivel !== 2) {
      dispatch(
        getOutstandingDebitsList(
          profileNivelState.idLegado,
          outstandingDebitsFilterState.fare,
          outstandingDebitsFilterState.initialDate,
          outstandingDebitsFilterState.finalDate
        )
      );
    } else {
      dispatch(
        getOutstandingDebitsList(
          outstandingDebitsFilterState.partner,
          outstandingDebitsFilterState.fare,
          outstandingDebitsFilterState.initialDate,
          outstandingDebitsFilterState.finalDate
        )
      );
    }
  }

  function searchFare() {
    if (
      moment(outstandingDebitsFilterState.initialDate) >
      moment(outstandingDebitsFilterState.finalDate)
    ) {
      return Swal.fire({
        icon: 'error',
        title: 'A data inicial não pode ser maior que a data final!',
        confirmButtonText: 'Tentar novamente',
      });
    }
    return dispathData();
  }

  return (
    <Filter.Default>
      <SetPartner />
      <SetFare />
      <SetInitialDate />
      <SetFinalDate />
      <SearchButton
        onClick={() => searchFare()}
        justifyContent="center"
        width="10rem"
      />
    </Filter.Default>
  );
}

export default OutstandingDebitsFilter;
